import { SortQueryDefaulted } from '@adflow/shared/util-data';

import type { ViewHistoryFacebookTemplateDto } from './history-facebook-template.dto';

const HistoryFacebookTemplateSortableFields: (keyof ViewHistoryFacebookTemplateDto)[] =
	['user', 'createdAt', 'action'] as const;

export const DEFAULT_HISTORY_FACEBOOK_TEMPLATE_SORT = 'createdAt';
export const DEFAULT_HISTORY_FACEBOOK_TEMPLATE_SORT_DIR = 'desc';

export const ListHistoryFacebookTemplateSort = SortQueryDefaulted(
	HistoryFacebookTemplateSortableFields,
	DEFAULT_HISTORY_FACEBOOK_TEMPLATE_SORT,
	DEFAULT_HISTORY_FACEBOOK_TEMPLATE_SORT_DIR
);
